import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

const DateComponent = ({
	value,
	onChange,
	width,
	label,
	required,
	disablePast = false,
	disableFuture = false,
}) => {
	return (
		<Box
			sx={{
				width: {
					xs: "100%",
					md: width,
				},
			}}
		>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<DatePicker
					label={label}
					value={value}
					renderInput={(params) => (
						<TextField
							{...params}
							helperText={null}
							fullWidth
							required={required}
						/>
					)}
					onChange={onChange}
					disablePast={disablePast}
					disableFuture={disableFuture}
				/>
			</LocalizationProvider>
		</Box>
	);
};

export default DateComponent;
